import React, { Fragment } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const PengaturanModal = ({ button, title, isOpen, toggle, size, children }) => {
  return (
    <Fragment>
      {button}
      <Modal isOpen={isOpen} toggle={toggle} backdrop={"static"} size={size}>
        <ModalHeader toggle={toggle}>{title}</ModalHeader>
        <ModalBody>{children}</ModalBody>
      </Modal>
    </Fragment>
  );
};

export default PengaturanModal;
